import { render, staticRenderFns } from "./BaseAddEditContact.vue?vue&type=template&id=721be163&scoped=true&"
import script from "./BaseAddEditContact.vue?vue&type=script&lang=js&"
export * from "./BaseAddEditContact.vue?vue&type=script&lang=js&"
import style0 from "./BaseAddEditContact.vue?vue&type=style&index=0&id=721be163&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721be163",
  null
  
)

export default component.exports